/**
 * Bootstrap — React 19 + Vite entry point.
 * i18n imported first so direction is set before first render.
 */
import "./i18n";
import { SyncProvider } from "@/shared/components/SyncProvider";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles/globals.css";
import App from "./app/App.tsx";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <SyncProvider />
    <App />
  </StrictMode>,
);